const couponProduction = true
const production = true

const IP = production ? "app-api.elevatelifestyle.in" : "192.168.1.38"
const CouponIP = couponProduction ? "api.elevatelifestyle.in" : "192.168.1.38"

const Protocol = production ? "https://" : "http://"
const couponProtocol = couponProduction ? "https://" : "http://"//////


export const projectKey = '54Kury8wYk'

export const secretKey = '698301000af143f2724b5ba8'

const BaseUrl = `${Protocol}${IP}/`

const GatewayBase = production ? `${Protocol}${IP}` : `${Protocol}${IP}:1010`
const CouponGatewayBase = couponProduction ? `${couponProtocol}${CouponIP}` : `${couponProtocol}${CouponIP}:3001`
// Always use production for file upl
const FileUploadGatewayBase = `https://app-api.elevatelifestyle.in`

// New File Upload Servic
const NewFileUploadBase = `https://upload.headsupcorporation.com/api`

// Services
export const UserService = '/userservice/'
export const AuthService = '/auth/'
export const OurBestService = '/generalservice/'
export const CartService = '/cartservices/'
export const SalonServices = '/generalservice/'
export const BookingServices = '/bookingservices/'
export const Specialists = '/specialists/'
export const StaffManagement = '/staffManagement/'
export const AdvertisementService = '/advertisementservice/'
export const MediaService = '/mediaservice/'
export const FileService = '/fileservice/'
export const ProductService = '/generalservice/'
export const MembershipService = '/billingservice/'
export const PackageService = '/billingservice/'
export const RoleService = '/userservice/'
export const GeneralService = '/generalservice/'
export const SeatService = '/seatsservice/'
export const ClientService = '/generalservice/'
export const UnitService = '/generalservice/'
export const InventoryService = '/generalservice/'
export const AttendanceService = '/generalservice/'
export const VendorService = '/generalservice/'
export const OrderService = '/generalservice/'
export const billingservice = '/billingservice/'
export const orders = "/orders/"
export const taskservice = '/generalservice/'
export const taskevidenceservice = '/generalservice/'
export const surveyService = "/surveyservice/"
export const clientsurveyservice = "/clientsurveyservice/"
export const closingService = "/closingservice/"
export const expenseService = "/expenseservice/"
export const CouponService = "/billingservice/"
export const KioskService = "/kioskservice/"

export const cronservice = "/generalservice/"
export const AppControlService = '/appcontrolservice/'


// Configuration Constants
export const domainId = '21676'
// Authentication APIs
export const login = GatewayBase + AuthService + 'login'
export const forgotPassword = GatewayBase + AuthService + 'forgot-password'
export const resetPassword = GatewayBase + AuthService + 'reset-password'
export const otp = '/otp/'
export const sendOtp = GatewayBase + otp + "send"
export const verifyOtp = GatewayBase + otp + "verify"

// User Management
export const addUser = GatewayBase + UserService + 'addUser'
export const updateUser = GatewayBase + UserService + 'updateUser'
export const searchUser = GatewayBase + UserService + 'searchUser'
export const deleteUser = GatewayBase + UserService + 'deleteUser'


// Staff Management
// export const addStaff = GatewayBase + StaffService + 'addStaff'
// export const updateStaff = GatewayBase + StaffService + 'updateStaff'
// export const searchStaff = GatewayBase + StaffService + 'searchStaff'
// export const deleteStaff = GatewayBase + StaffService + 'deleteStaff'

// Role Management
export const addRole = GatewayBase + RoleService + 'addRole'
export const updateRole = GatewayBase + RoleService + 'updateRole'
export const searchRole = GatewayBase + RoleService + 'searchRole'
export const deleteRole = GatewayBase + RoleService + 'deleteRole'

// Best Service Management
// export const addBestService = GatewayBase + OurBestService + 'addBestService'
// export const updateBestService = GatewayBase + OurBestService + 'updateBestService'
// export const searchBestService = GatewayBase + OurBestService + 'searchBestService'
// export const deleteBestService = GatewayBase + OurBestService + 'deleteBestService'

// Cart Management
export const addCart = GatewayBase + CartService + 'addCart'
export const searchCart = GatewayBase + CartService + 'searchCart'
export const deleteCart = GatewayBase + CartService + 'deleteCart'

// Booking Management
export const addBooking = GatewayBase + BookingServices + 'addBooking'
export const searchBooking = GatewayBase + BookingServices + 'searchBooking'

// Advertisement Management
export const addAdvertisement = GatewayBase + AdvertisementService + 'addAdvertisement'
export const updateAdvertisement = GatewayBase + AdvertisementService + 'updateAdvertisement'
export const searchAdvertisement = GatewayBase + AdvertisementService + 'searchAdvertisement'
export const deleteAdvertisement = GatewayBase + AdvertisementService + 'deleteAdvertisement'

// Media Management
export const addMedia = GatewayBase + GeneralService + 'addMedia'
export const updateMedia = GatewayBase + GeneralService + 'updateMedia'
export const searchMedia = GatewayBase + GeneralService + 'searchMedia'
export const deleteMedia = GatewayBase + GeneralService + 'deleteMedia'
export const incrementView = GatewayBase + GeneralService + 'incrementView'

// Kiosk Management
export const addKiosk = GatewayBase + KioskService + 'addKiosk'
export const searchKiosk = GatewayBase + KioskService + 'searchKiosk'
export const updateKiosk = GatewayBase + KioskService + 'updateKiosk'
export const deleteKiosk = GatewayBase + KioskService + 'deleteKiosk'
export const searchKioskHomePage = GatewayBase + KioskService + 'home-page/search'
export const getActiveKioskHomePage = GatewayBase + KioskService + 'home-page/active'
export const addKioskHomePage = GatewayBase + KioskService + 'home-page'
export const updateKioskHomePage = GatewayBase + KioskService + 'home-page'
export const deleteKioskHomePage = GatewayBase + KioskService + 'home-page'
export const publishKioskHomePage = GatewayBase + KioskService + 'home-page'
export const duplicateKioskHomePage = GatewayBase + KioskService + 'home-page'

// Payment QR Management
export const addPaymentQR = GatewayBase + KioskService + 'addPaymentQR'
export const updatePaymentQR = GatewayBase + KioskService + 'updatePaymentQR'
export const searchPaymentQR = GatewayBase + KioskService + 'searchPaymentQR'
export const deletePaymentQR = GatewayBase + KioskService + 'deletePaymentQR'

// Banner Management
export const addBanner = GatewayBase + KioskService + 'addBanner'
export const addMultipleBanners = GatewayBase + KioskService + 'addMultipleBanners'
export const searchBanners = GatewayBase + KioskService + 'searchBanners'
export const updateBanner = GatewayBase + KioskService + 'updateBanner'
export const deleteBanner = GatewayBase + KioskService + 'deleteBanner'
export const updateBannerOrder = GatewayBase + KioskService + 'updateBannerOrder'
export const incrementBannerView = GatewayBase + KioskService + 'incrementBannerView'

// Ad Management
export const addAd = GatewayBase + KioskService + 'addAd'
export const addMultipleAds = GatewayBase + KioskService + 'addMultipleAds'
export const searchAds = GatewayBase + KioskService + 'searchAds'
export const updateAd = GatewayBase + KioskService + 'updateAd'
export const deleteAd = GatewayBase + KioskService + 'deleteAd'
export const updateAdOrder = GatewayBase + KioskService + 'updateAdOrder'
export const incrementAdView = GatewayBase + KioskService + 'incrementAdView'

// Device Management
export const registerDevice = GatewayBase + GeneralService + 'registerDevice'
export const updateDevice = GatewayBase + GeneralService + 'updateDevice'
export const searchDevice = GatewayBase + GeneralService + 'searchDevice'
export const deleteDevice = GatewayBase + GeneralService + 'deleteDevice'

// File Management

export const uploadSingle = FileUploadGatewayBase + FileService + 'upload'
export const uploadSingleNew = NewFileUploadBase + '/upload'
export const searchFiles = GatewayBase + FileService + 'searchFiles'
export const deleteFile = GatewayBase + FileService + 'deleteFile'

// Salon Services Management
export const addServices = GatewayBase + SalonServices + 'addServices'
export const updateServices = GatewayBase + SalonServices + 'updateServices'
export const searchServices = GatewayBase + SalonServices + 'searchServices'
export const deleteServices = GatewayBase + SalonServices + 'deleteServices'

// Parent Service Management
export const addParent = GatewayBase + SalonServices + 'addParent'
export const updateParent = GatewayBase + SalonServices + 'updateParent'
export const searchParent = GatewayBase + SalonServices + 'searchParent'
export const deleteParent = GatewayBase + SalonServices + 'deleteParent'
export const ParentBulkUpload = GatewayBase + SalonServices + 'bulk-upload'

//Salon Parent Service Management
export const addSalonParent = GatewayBase + SalonServices + 'addSalonParent'
export const updateSalonParent = GatewayBase + SalonServices + 'updateSalonParent'
export const searchSalonParent = GatewayBase + SalonServices + 'searchSalonParent'
export const deleteSalonParent = GatewayBase + SalonServices + 'deleteSalonParent'

// Child Service Management
export const addChild = GatewayBase + SalonServices + 'addChild'
export const updateChild = GatewayBase + SalonServices + 'updateChild'
export const searchChild = GatewayBase + SalonServices + 'searchChild'
export const deleteChild = GatewayBase + SalonServices + 'deleteChild'


//Salon Child Service Management
export const addSalonChild = GatewayBase + SalonServices + 'addSalonChild'
export const updateSalonChild = GatewayBase + SalonServices + 'updateSalonChild'
export const searchSalonChild = GatewayBase + SalonServices + 'searchSalonChild'
export const deleteSalonChild = GatewayBase + SalonServices + 'deleteSalonChild'

// App APIs (Mobile App)
export const appConfig = GatewayBase + GeneralService + 'app/config'
export const appHome = GatewayBase + GeneralService + 'app/home'
export const appParentService = GatewayBase + GeneralService + 'app/parent-service'
export const appBannersApi = GatewayBase + GeneralService + 'app/banners'

// App Banner Management (Admin)
export const addAppBanner = GatewayBase + GeneralService + 'addAppBanner'
export const searchAppBanner = GatewayBase + GeneralService + 'searchAppBanner'
export const updateAppBanner = GatewayBase + GeneralService + 'updateAppBanner'
export const deleteAppBanner = GatewayBase + GeneralService + 'deleteAppBanner'

// App Configuration Management (Admin)
export const getAppConfig = GatewayBase + GeneralService + 'getAppConfig'
export const updateAppConfig = GatewayBase + GeneralService + 'updateAppConfig'

// App Section Client Management (Admin)
export const addAppSectionClient = GatewayBase + GeneralService + 'addAppSectionClient'
export const searchAppSectionClient = GatewayBase + GeneralService + 'searchAppSectionClient'
export const updateAppSectionClient = GatewayBase + GeneralService + 'updateAppSectionClient'
export const deleteAppSectionClient = GatewayBase + GeneralService + 'deleteAppSectionClient'
export const addServiceToSection = GatewayBase + GeneralService + 'addServiceToSection'
export const removeServiceFromSection = GatewayBase + GeneralService + 'removeServiceFromSection'
export const reorderSectionServices = GatewayBase + GeneralService + 'reorderSectionServices'
export const reorderSections = GatewayBase + GeneralService + 'reorderSections'
export const toggleSectionVisibility = GatewayBase + GeneralService + 'toggleSectionVisibility'
export const getClientSections = GatewayBase + GeneralService + 'app/sections'
export const addCategoryToSection = GatewayBase + GeneralService + 'addCategoryToSection'
export const removeCategoryFromSection = GatewayBase + GeneralService + 'removeCategoryFromSection'
//AtHome Parent Service Management
export const addAtHomeParent = GatewayBase + SalonServices + 'addAtHomeParent'
export const updateAtHomeParent = GatewayBase + SalonServices + 'updateAtHomeParent'
export const searchAtHomeParent = GatewayBase + SalonServices + 'searchAtHomeParent'
export const deleteAtHomeParent = GatewayBase + SalonServices + 'deleteAtHomeParent'

//AtHome Child Service Management
export const addAtHomeChild = GatewayBase + SalonServices + 'addAtHomeChild'
export const updateAtHomeChild = GatewayBase + SalonServices + 'updateAtHomeChild'
export const searchAtHomeChild = GatewayBase + SalonServices + 'searchAtHomeChild'
export const deleteAtHomeChild = GatewayBase + SalonServices + 'deleteAtHomeChild'

//Kios Prent Service Management
export const addKiosParent = GatewayBase + SalonServices + 'addKiosParent'
export const updateKiosParent = GatewayBase + SalonServices + 'updateKiosParent'
export const searchKiosParent = GatewayBase + SalonServices + 'searchKiosParent'
export const deleteKiosParent = GatewayBase + SalonServices + 'deleteKiosParent'

//Kios Child Service Management
export const addKiosChild = GatewayBase + SalonServices + 'addKiosChild'
export const updateKiosChild = GatewayBase + SalonServices + 'updateKiosChild'
export const searchKiosChild = GatewayBase + SalonServices + 'searchKiosChild'
export const deleteKiosChild = GatewayBase + SalonServices + 'deleteKiosChild'

// Staff Management
export const addStaff = GatewayBase + StaffManagement + 'addStaff'
export const updateStaff = GatewayBase + StaffManagement + 'updateStaff'
export const searchStaff = GatewayBase + StaffManagement + 'searchStaff'
export const deleteStaff = GatewayBase + StaffManagement + 'deleteStaff'
export const StaffBulkUpload = GatewayBase + StaffManagement + 'bulk-upload'

// Specialists Management
export const searchSpecialists = BaseUrl + Specialists + 'searchSpecialists'

// Product Management
export const addProduct = GatewayBase + ProductService + 'addProduct'
export const updateProduct = GatewayBase + ProductService + 'updateProduct'
export const searchProduct = GatewayBase + ProductService + 'searchProduct'
export const deleteProduct = GatewayBase + ProductService + 'deleteProduct'
export const ProductBulkUpload = GatewayBase + ProductService + 'bulk-upload'

// Membership Management
export const addMembership = GatewayBase + MembershipService + 'addMembership'
export const updateMembership = GatewayBase + MembershipService + 'updateMembership'
export const searchMembership = GatewayBase + MembershipService + 'searchMembership'
export const deleteMembership = GatewayBase + MembershipService + 'deleteMembership'
export const MembershipBulkUpload = GatewayBase + MembershipService + 'bulk-upload'

export const addClientMembership = GatewayBase + MembershipService + 'addClientMembership'
export const searchClientMembership = GatewayBase + MembershipService + 'searchClientMembership'
export const updateClientMembership = GatewayBase + MembershipService + 'updateClientMembership'
export const deleteClientMembership = GatewayBase + MembershipService + 'deleteClientMembership'



// Package Management
export const addPackage = GatewayBase + PackageService + 'addPackage'
export const updatePackage = GatewayBase + PackageService + 'updatePackage'
export const searchPackage = GatewayBase + PackageService + 'searchPackage'
export const deletePackage = GatewayBase + PackageService + 'deletePackage'



//General Master

export const addGeneralMaster = GatewayBase + GeneralService + 'addGeneral'
export const updateGeneralMaster = GatewayBase + GeneralService + 'updateGeneral'
export const searchGeneralMaster = GatewayBase + GeneralService + 'searchGeneral'
export const deleteGeneralMaster = GatewayBase + GeneralService + 'deleteGeneral'


//Seat Management

export const addSeat = GatewayBase + SeatService + 'addSeat'
export const updateSeat = GatewayBase + SeatService + 'updateSeat'
export const searchSeat = GatewayBase + SeatService + 'searchSeat'
export const deleteSeat = GatewayBase + SeatService + 'deleteSeat'


//ClientManagement

export const addClient = GatewayBase + ClientService + 'addClients'
export const updateClient = GatewayBase + ClientService + 'updateClients'
export const deleteClient = GatewayBase + ClientService + 'deleteClients'
export const searchClient = GatewayBase + ClientService + 'searchClients'

//graphql 
export const graphql = GatewayBase + SeatService + '/graphql'

// Unit 

export const addUnit = GatewayBase + UnitService + 'addUnit'
export const updateUnit = GatewayBase + UnitService + 'updateUnit'
export const searchUnit = GatewayBase + UnitService + 'searchUnit'
export const deleteUnit = GatewayBase + UnitService + 'deleteUnit'


// attedence

export const addAttendance = GatewayBase + AttendanceService + 'addAttendance'
export const updateAttendance = GatewayBase + AttendanceService + 'updateAttendance'
export const searchAttendance = GatewayBase + AttendanceService + 'searchAttendance'
export const deleteAttendance = GatewayBase + AttendanceService + 'deleteAttendance'


export const WsSeatGraphql = GatewayBase + SeatService + 'graphql'
export const seatGraphql = GatewayBase + SeatService + 'graphql'



//Inventory

export const addInventory = GatewayBase + InventoryService + 'addInventory'
export const bulkAddInventory = GatewayBase + InventoryService + 'bulkAddInventory'
export const searchInventory = GatewayBase + InventoryService + 'searchInventory'
export const updateInventory = GatewayBase + InventoryService + 'updateInventory'
export const deleteInventory = GatewayBase + InventoryService + 'deleteInventory'

//Inventory Transaction
export const addInventoryTransaction = GatewayBase + InventoryService + 'addInventoryTransaction'
export const searchInventoryTransaction = GatewayBase + InventoryService + 'searchInventoryTransaction'
export const updateInventoryTransaction = GatewayBase + InventoryService + 'updateInventoryTransaction'
export const deleteInventoryTransaction = GatewayBase + InventoryService + 'deleteInventoryTransaction'

//Warehouse

export const addProductInWarehouse = GatewayBase + InventoryService + 'addProductInWarehouse'
export const searchWarehouse = GatewayBase + InventoryService + 'searchWarehouse'
export const transferFromWarehouseToShelf = GatewayBase + InventoryService + 'transferFromWarehouseToShelf'
export const searchShelfInventory = GatewayBase + InventoryService + 'searchShelfInventory'
export const searchShelfDashboard = GatewayBase + InventoryService + 'searchShelfDashboard'

// Stock Management
export const addStock = GatewayBase + InventoryService + 'addStock'
export const searchStock = GatewayBase + InventoryService + 'searchStock'
export const updateStock = GatewayBase + InventoryService + 'updateStock'
export const deleteStock = GatewayBase + InventoryService + 'deleteStock'

// Stock Transaction Management
export const addStockTransaction = GatewayBase + InventoryService + 'addStockTransaction'
export const searchStockTransaction = GatewayBase + InventoryService + 'searchStockTransaction'
export const updateStockTransaction = GatewayBase + InventoryService + 'updateStockTransaction'
export const deleteStockTransaction = GatewayBase + InventoryService + 'deleteStockTransaction'
export const cancelStockTransaction = GatewayBase + InventoryService + 'cancelStockTransaction'
export const acceptStockTransaction = GatewayBase + InventoryService + 'acceptStockTransaction'
export const rejectStockTransaction = GatewayBase + InventoryService + 'rejectStockTransaction'


// vendor

export const addVendor = GatewayBase + VendorService + 'addVendor'
export const updateVendor = GatewayBase + VendorService + 'updateVendor'
export const searchVendor = GatewayBase + VendorService + 'searchVendor'
export const deleteVendor = GatewayBase + VendorService + 'deleteVendor'


// Order

export const addOrder = GatewayBase + OrderService + 'addOrder'
export const updateOrder = GatewayBase + OrderService + 'updateOrder'
export const searchOrder = GatewayBase + OrderService + 'searchOrder'
export const deleteOrder = GatewayBase + OrderService + 'deleteOrder'





// billingservice
export const addBilling = GatewayBase + billingservice + 'addBilling'
export const updateBilling = GatewayBase + billingservice + 'updateBill'
export const deleteBilling = GatewayBase + billingservice + 'deleteBilling'
export const searchBilling = GatewayBase + billingservice + 'searchBilling'

// Bill Management Endpoints
export const addBill = GatewayBase + billingservice + 'addBill'
export const searchBill = GatewayBase + billingservice + 'searchBill'
export const updateBill = GatewayBase + billingservice + 'updateBill'
export const deleteBill = GatewayBase + billingservice + 'deleteBill'

// Payment Management
export const searchPayment = GatewayBase + billingservice + 'searchPayment'
export const getPaymentsByClient = GatewayBase + billingservice + 'getPaymentsByClient'

// App Bookings
export const searchAppBooking = GatewayBase + billingservice + 'searchBooking'
export const acceptBooking = GatewayBase + billingservice + 'acceptBooking'
export const updateAppBooking = GatewayBase + billingservice + 'updateBooking'
export const rescheduleBookingApi = GatewayBase + billingservice + 'rescheduleBooking'


// surveyService
export const addSurvey = GatewayBase + surveyService + 'addSurvey'
export const updateSurvey = GatewayBase + surveyService + 'updateSurvey'
export const deleteSurvey = GatewayBase + surveyService + 'deleteSurvey'
export const searchSurvey = GatewayBase + surveyService + 'searchSurvey'

// surveyService
export const addClientSurvey = GatewayBase + clientsurveyservice + 'addClientSurvey'
export const updateClientSurvey = GatewayBase + clientsurveyservice + 'updateClientSurvey'
export const deleteClientSurvey = GatewayBase + clientsurveyservice + 'deleteClientSurvey'
export const searchClientSurvey = GatewayBase + clientsurveyservice + 'searchClientSurvey'

// closingService
export const addClosing = GatewayBase + closingService + 'addClosing'
export const updateClosing = GatewayBase + closingService + 'updateClosing'
export const deleteClosing = GatewayBase + closingService + 'deleteClosing'
export const searchClosing = GatewayBase + closingService + 'searchClosing'

// Expense service
export const addExpense = GatewayBase + expenseService + 'addExpense'
export const updateExpense = GatewayBase + expenseService + 'updateExpense'
export const deleteExpense = GatewayBase + expenseService + 'deleteExpense'
export const searchExpense = GatewayBase + expenseService + 'searchExpense'


// Our Best Service
export const addBestService = GatewayBase + OurBestService + 'addBestService'
export const updateBestService = GatewayBase + OurBestService + 'updateBestService'
export const deleteBestService = GatewayBase + OurBestService + 'deleteBestService'
export const searchBestService = GatewayBase + OurBestService + 'searchBestService'

// Payment Method Management
export const addPaymentMethod = GatewayBase + GeneralService + 'addPaymentMethod'
export const updatePaymentMethod = GatewayBase + GeneralService + 'updatePaymentMethod'
export const searchPaymentMethod = GatewayBase + GeneralService + 'searchPaymentMethod'
export const deletePaymentMethod = GatewayBase + GeneralService + 'deletePaymentMethod'

//coupon 

export const verifyCoupon = CouponGatewayBase + '/api/customer/verify-coupon'
export const purchaseCoupon = CouponGatewayBase + '/api/admin/purchase'

// Coupon Management Endpoints
export const addCoupon = GatewayBase + CouponService + 'addCoupon'
export const searchCoupon = GatewayBase + CouponService + 'searchCoupon'
export const updateCoupon = GatewayBase + CouponService + 'updateCoupon'
export const deleteCoupon = GatewayBase + CouponService + 'deleteCoupon'
export const validateCoupon = GatewayBase + CouponService + 'validateCoupon'


//Payments

// export const orederCreate = GatewayBase + orders + 'create-order'
export const searchWalletBalance = GatewayBase + orders + 'searchWalletBalance'
export const orederCreateTopup = GatewayBase + orders + "wallet/topup" + "/create"
export const verifyPayment = GatewayBase + orders + 'verify-payment'
export const orderCreateOnline = GatewayBase + orders + 'service/payment' + "/create"
export const walletPay = GatewayBase + orders + "wallet" + "/pay"


//task

export const createTask = GatewayBase + taskservice + 'createTask'
export const searchTask = GatewayBase + taskservice + 'searchTask'
export const deleteTask = GatewayBase + taskservice + 'deleteTask'
export const updateTask = GatewayBase + taskservice + 'updateTask'
export const searchEvidence = GatewayBase + taskevidenceservice + 'searchTaskEvidence'
export const updateTaskEvidence = GatewayBase + taskevidenceservice + 'updateTaskEvidence'


//wallet

export const searchWallet = GatewayBase + billingservice + 'searchWallet'
export const verifyWalletOtp = GatewayBase + billingservice + 'verifyWalletOtp'

// Cash Balance Management
export const addCashBalance = GatewayBase + billingservice + 'addCashBalance'
export const searchCashBalance = GatewayBase + billingservice + 'searchCashBalance'
export const updateCashBalance = GatewayBase + billingservice + 'updateCashBalance'
export const deleteCashBalance = GatewayBase + billingservice + 'deleteCashBalance'

// Cash Transaction Management
export const addCashTransaction = GatewayBase + billingservice + 'addCashTransaction'
export const updateCashTransaction = GatewayBase + billingservice + 'updateCashTransaction'
export const searchCashTransaction = GatewayBase + billingservice + 'searchCashTransaction'

// Account Management
export const searchAccount = GatewayBase + billingservice + 'searchAccount'
export const searchAccountTransaction = GatewayBase + billingservice + 'searchAccountTransaction'

// Incentive Management
export const addIncentiveProgram = GatewayBase + billingservice + 'addIncentiveProgram'
export const searchIncentiveProgram = GatewayBase + billingservice + 'searchIncentiveProgram'
export const updateIncentiveProgram = GatewayBase + billingservice + 'updateIncentiveProgram'
export const deleteIncentiveProgram = GatewayBase + billingservice + 'deleteIncentiveProgram'
export const searchIncentive = GatewayBase + billingservice + 'searchIncentive'
export const updateIncentive = GatewayBase + billingservice + 'updateIncentive'
export const calculateDailyIncentive = GatewayBase + billingservice + 'calculateDailyIncentive'

// Dashboard Management
export const searchDashboard = GatewayBase + billingservice + 'searchDashboard'
export const searchLiveStockDashboard = GatewayBase + GeneralService + 'searchLiveStockDashboard'
export const getStockDashboard = GatewayBase + InventoryService + 'getStockDashboard'


// Client Feedback
export const searchFeedback = GatewayBase + GeneralService + 'searchFeedback'
export const deleteFeedback = GatewayBase + GeneralService + 'deleteFeedback'

//Clinet Followups
export const addServiceFollowup = GatewayBase + ClientService + '/addServiceFollowup'
export const searchServiceFollowup = GatewayBase + ClientService + '/searchServiceFollowup'
export const updateServiceFollowup = GatewayBase + ClientService + '/updateServiceFollowup'
export const deleteServiceFollowup = GatewayBase + ClientService + '/deleteServiceFollowup'



//cron service

export const triggerMonthlyTask = GatewayBase + cronservice + "trigger-monthly-task"

// Category Management
export const addCategory = GatewayBase + GeneralService + 'addCategory'
export const searchCategory = GatewayBase + GeneralService + 'searchCategory'
export const updateCategory = GatewayBase + GeneralService + 'updateCategory'
export const deleteCategory = GatewayBase + GeneralService + 'deleteCategory'
export const transferCategory = GatewayBase + GeneralService + 'transferCategory'
export const bulkTransferCategory = GatewayBase + GeneralService + 'bulkTransferCategory'

// SubCategory Management
export const addSubCategory = GatewayBase + GeneralService + 'addSubCategory'
export const searchSubCategory = GatewayBase + GeneralService + 'searchSubCategory'
export const updateSubCategory = GatewayBase + GeneralService + 'updateSubCategory'
export const deleteSubCategory = GatewayBase + GeneralService + 'deleteSubCategory'
export const transferSubCategory = GatewayBase + GeneralService + 'transferSubCategory'
export const bulkTransferSubCategory = GatewayBase + GeneralService + 'bulkTransferSubCategory'

// Service Management
export const addService = GatewayBase + GeneralService + 'addService'
export const searchService = GatewayBase + GeneralService + 'searchService'
export const updateService = GatewayBase + GeneralService + 'updateService'
export const deleteService = GatewayBase + GeneralService + 'deleteService'
export const transferService = GatewayBase + GeneralService + 'transferService'
export const bulkTransferService = GatewayBase + GeneralService + 'bulkTransferService'

// Hair Color Service Management
export const addHairColorService = GatewayBase + GeneralService + 'addHairColorService'
export const searchHairColorService = GatewayBase + GeneralService + 'searchHairColorService'
export const updateHairColorService = GatewayBase + GeneralService + 'updateHairColorService'
export const deleteHairColorService = GatewayBase + GeneralService + 'deleteHairColorService'

// Group Management
export const addGroup = GatewayBase + GeneralService + 'addGroup'
export const searchGroup = GatewayBase + GeneralService + 'searchGroup'
export const updateGroup = GatewayBase + GeneralService + 'updateGroup'
export const deleteGroup = GatewayBase + GeneralService + 'deleteGroup'

// ProductGroup Management
export const searchProductGroup = GatewayBase + GeneralService + 'searchProductGroup'
export const addProductGroup = GatewayBase + GeneralService + 'addProductGroup'
export const updateProductGroup = GatewayBase + GeneralService + 'updateProductGroup'
export const deleteProductGroup = GatewayBase + GeneralService + 'deleteProductGroup'

// ProductCategory Management
export const searchProductCategory = GatewayBase + GeneralService + 'searchProductCategory'
export const addProductCategory = GatewayBase + GeneralService + 'addProductCategory'
export const updateProductCategory = GatewayBase + GeneralService + 'updateProductCategory'
export const deleteProductCategory = GatewayBase + GeneralService + 'deleteProductCategory'
export const transferProductCategory = GatewayBase + GeneralService + 'transferProductCategory'

// ProductSubCategory Management
export const searchProductSubCategory = GatewayBase + GeneralService + 'searchProductSubCategory'
export const addProductSubCategory = GatewayBase + GeneralService + 'addProductSubCategory'
export const updateProductSubCategory = GatewayBase + GeneralService + 'updateProductSubCategory'
export const deleteProductSubCategory = GatewayBase + GeneralService + 'deleteProductSubCategory'
export const transferProductSubCategory = GatewayBase + GeneralService + 'transferProductSubCategory'

// ProductBrand Management
export const searchProductBrand = GatewayBase + GeneralService + 'searchProductBrand'
export const addProductBrand = GatewayBase + GeneralService + 'addProductBrand'
export const updateProductBrand = GatewayBase + GeneralService + 'updateProductBrand'
export const deleteProductBrand = GatewayBase + GeneralService + 'deleteProductBrand'
export const transferProductBrand = GatewayBase + GeneralService + 'transferProductBrand'



// Website Configuration (Landing Page)
export const getWebsiteConfig = GatewayBase + GeneralService + 'getWebsiteConfig'
export const updateWebsiteConfig = GatewayBase + GeneralService + 'updateWebsiteConfig'

// Website Sections (Landing Page)
export const addWebsiteSection = GatewayBase + GeneralService + 'addWebsiteSection'
export const searchWebsiteSection = GatewayBase + GeneralService + 'searchWebsiteSection'
export const updateWebsiteSection = GatewayBase + GeneralService + 'updateWebsiteSection'
export const deleteWebsiteSection = GatewayBase + GeneralService + 'deleteWebsiteSection'
export const toggleWebsiteSectionVisibility = GatewayBase + GeneralService + 'toggleWebsiteSectionVisibility'
export const reorderWebsiteSections = GatewayBase + GeneralService + 'reorderWebsiteSections'
export const seedDefaultWebsiteSections = GatewayBase + GeneralService + 'seedDefaultWebsiteSections'

//App configuration

export const addConfigProject = GatewayBase + GeneralService + 'addConfigProject'
export const searchConfigProject = GatewayBase + GeneralService + 'searchConfigProject'
export const updateConfigProject = GatewayBase + GeneralService + 'updateConfigProject'
export const deleteConfigProject = GatewayBase + GeneralService + 'deleteConfigProject'

// Screen Configuration
export const addScreenConfig = GatewayBase + GeneralService + 'addScreenConfig'
export const searchScreenConfig = GatewayBase + GeneralService + 'searchScreenConfig'
export const updateScreenConfig = GatewayBase + GeneralService + 'updateScreenConfig'
export const deleteScreenConfig = GatewayBase + GeneralService + 'deleteScreenConfig'






// App Control Management
export const addAppControl = GatewayBase + AppControlService + 'addAppControl'
export const searchAppControl = GatewayBase + AppControlService + 'searchAppControl'
export const updateAppControl = GatewayBase + AppControlService + 'updateAppControl'
export const deleteAppControl = GatewayBase + AppControlService + 'deleteAppControl'
export const getAppControlByKey = GatewayBase + AppControlService + 'getAppControlByKey'
export const getAllActiveAppControls = GatewayBase + AppControlService + 'getAllActiveAppControls'
export const searchNearbySalons = GatewayBase + AppControlService + 'searchNearbySalons'

// App Category Management
export const addAppCategory = GatewayBase + AppControlService + 'addAppCategory'
export const searchAppCategory = GatewayBase + AppControlService + 'searchAppCategory'
export const updateAppCategory = GatewayBase + AppControlService + 'updateAppCategory'
export const deleteAppCategory = GatewayBase + AppControlService + 'deleteAppCategory'

// Home Section Management
export const addHomeSection = GatewayBase + AppControlService + 'addHomeSection'
export const searchHomeSection = GatewayBase + AppControlService + 'searchHomeSection'
export const updateHomeSection = GatewayBase + AppControlService + 'updateHomeSection'
export const deleteHomeSection = GatewayBase + AppControlService + 'deleteHomeSection'

// Maintenance Mode Management
export const addMaintenanceMode = GatewayBase + AppControlService + 'addMaintenanceMode'
export const searchMaintenanceMode = GatewayBase + AppControlService + 'searchMaintenanceMode'
export const updateMaintenanceMode = GatewayBase + AppControlService + 'updateMaintenanceMode'
export const deleteMaintenanceMode = GatewayBase + AppControlService + 'deleteMaintenanceMode'
export const toggleMaintenanceMode = GatewayBase + AppControlService + 'toggleMaintenanceMode'
export const getMaintenanceStatus = GatewayBase + AppControlService + 'getMaintenanceStatus'

// Online Users
export const getOnlineUsers = GatewayBase + AppControlService + 'getOnlineUsers'

// OTA Hot Updates
export const addOtaUpdate = GatewayBase + AppControlService + 'addOtaUpdate'
export const uploadOtaBundle = GatewayBase + AppControlService + 'uploadOtaBundle'
export const searchOtaUpdate = GatewayBase + AppControlService + 'searchOtaUpdate'
export const updateOtaUpdate = GatewayBase + AppControlService + 'updateOtaUpdate'
export const deleteOtaUpdate = GatewayBase + AppControlService + 'deleteOtaUpdate'

// App Version Control
export const addAppVersion = GatewayBase + AppControlService + 'addAppVersion'
export const searchAppVersion = GatewayBase + AppControlService + 'searchAppVersion'
export const updateAppVersion = GatewayBase + AppControlService + 'updateAppVersion'
export const deleteAppVersion = GatewayBase + AppControlService + 'deleteAppVersion'
export const checkAppVersion = GatewayBase + AppControlService + 'checkAppVersion'

// Push Notification Management
export const sendNotificationApi = GatewayBase + GeneralService + 'sendNotification'
export const sendBulkNotificationApi = GatewayBase + GeneralService + 'sendBulkNotification'
export const searchNotificationApi = GatewayBase + GeneralService + 'searchNotification'
export const getClientNotificationsApi = GatewayBase + GeneralService + 'getClientNotifications'
export const searchPushTokenApi = GatewayBase + GeneralService + 'searchPushToken'

// Partner Analytics
export const getPartnerAnalytics = GatewayBase + GeneralService + 'getPartnerAnalytics'
export const updatePartner = GatewayBase + GeneralService + 'updateStaff'
export const togglePartnerBlock = GatewayBase + GeneralService + 'togglePartnerBlock'
export const searchStaffGeneral = GatewayBase + GeneralService + 'searchStaff'

// Staff Reviews
export const addStaffReview = GatewayBase + GeneralService + 'addStaffReview'
export const searchStaffReview = GatewayBase + GeneralService + 'searchStaffReview'
export const updateStaffReview = GatewayBase + GeneralService + 'updateStaffReview'
export const deleteStaffReview = GatewayBase + GeneralService + 'deleteStaffReview'
export const getStaffRating = GatewayBase + GeneralService + 'getStaffRating'

export const Available = 'Available';
export const Occupied = 'Occupied';
export const Initiated = 'Initiated';
export const InProgress = 'InProgress';



export const legendItems = [
  { color: "emerald-500", label: "Available" },
  { color: "blue-500", label: "Initiated" },
  { color: "rose-500", label: "Occupied" },
  { color: "amber-500", label: "Maintenance" }
];